import React from "react";

import Avatar, { AvatarItem, SizeType } from "@atlaskit/avatar";
import Skeleton from "@atlaskit/skeleton";
import { Box } from "@fuegokit/react";

import { JiraUser } from "../../../types";

interface AvatarItemCellProps {
  creator: JiraUser;
  size?: SizeType;
  loading?: boolean;
}

const loader = <Skeleton borderRadius={4} height="14px" width={80} isShimmering />;

export function AvatarItemCell({ creator, size = "medium", loading }: AvatarItemCellProps) {
  const displayName = creator?.displayName || "Unknown account";
  const avatarUrl = creator?.avatarUrls["24x24"] || "";
  return (
    <Box width={210} data-private>
      <AvatarItem primaryText={loading ? loader : displayName} avatar={<Avatar src={avatarUrl} size={size} />} />
    </Box>
  );
}
